import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildOtherMenuItems(t: TranslateFn): NavItem[] {
  return [
    {
      id: 'needlework',
      name: t('navigation.needlework.name'),
      link: '/subscriptions/graphics/needle-arts/',
      activePaths: [
        '/embroidery/',
        '/subscriptions/embroidery/',
        '/knitting/',
        '/subscriptions/knitting/',
      ],
      subMenuItems: [
        {
          id: 'embroidery',
          name: t('navigation.needlework.embroidery_designs.name'),
          link: '/embroidery/',
          subMenuItems: [
            {
              id: 'animals',
              name: t('navigation.needlework.embroidery_designs.animals.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.animals.name'),
                  link: '/subscriptions/embroidery/animals-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.quotes'),
                  link: '/subscriptions/embroidery/animals-embroidery/animal-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.baby_animals'),
                  link: '/subscriptions/embroidery/animals-embroidery/baby-animals/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.birds'),
                  link: '/subscriptions/embroidery/animals-embroidery/birds/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.bugs_insects'),
                  link: '/subscriptions/embroidery/animals-embroidery/bugs-insects/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.cats'),
                  link: '/subscriptions/embroidery/animals-embroidery/cats-animals-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.dinosaurs'),
                  link: '/subscriptions/embroidery/animals-embroidery/dinosaurs-animals-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.dogs'),
                  link: '/subscriptions/embroidery/animals-embroidery/dogs-animals-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.farm_animals'),
                  link: '/subscriptions/embroidery/animals-embroidery/farm-animals/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.fish_shells'),
                  link: '/subscriptions/embroidery/animals-embroidery/fish-shells/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.horses'),
                  link: '/subscriptions/embroidery/animals-embroidery/horses/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.marine_mammals'),
                  link: '/subscriptions/embroidery/animals-embroidery/marine-mammals/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.reptiles'),
                  link: '/subscriptions/embroidery/animals-embroidery/reptiles/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.wild_animals'),
                  link: '/subscriptions/embroidery/animals-embroidery/wild-animals/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.animals.woodland_animals'),
                  link: '/subscriptions/embroidery/animals-embroidery/woodland-animals/',
                },
              ],
            },
            {
              id: 'around_the_world',
              name: t('navigation.needlework.embroidery_designs.around_the_world.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.name'),
                  link: '/subscriptions/embroidery/around-the-world/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.africa'),
                  link: '/subscriptions/embroidery/around-the-world/africa/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.asia'),
                  link: '/subscriptions/embroidery/around-the-world/asia/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.australia'),
                  link: '/subscriptions/embroidery/around-the-world/australia-around-the-world/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.europe'),
                  link: '/subscriptions/embroidery/around-the-world/europe/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.around_the_world.mexico'),
                  link: '/subscriptions/embroidery/around-the-world/mexico-around-the-world/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.around_the_world.north_america',
                  ),
                  link: '/subscriptions/embroidery/around-the-world/north-america/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.around_the_world.south_america',
                  ),
                  link: '/subscriptions/embroidery/around-the-world/south-america/',
                },
              ],
            },
            {
              id: 'awareness_inspiration',
              name: t('navigation.needlework.embroidery_designs.awareness_inspiration.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.awareness_inspiration.name'),
                  link: '/subscriptions/embroidery/awareness-inspiration/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.awareness_inspiration.awareness',
                  ),
                  link: '/subscriptions/embroidery/awareness-inspiration/awareness-awareness-inspiration/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.awareness_inspiration.inspirational',
                  ),
                  link: '/subscriptions/embroidery/awareness-inspiration/inspirational/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.awareness_inspiration.remembrance',
                  ),
                  link: '/subscriptions/embroidery/awareness-inspiration/remembrance-awareness-inspiration/',
                },
              ],
            },
            {
              id: 'babies_kids',
              name: t('navigation.needlework.embroidery_designs.babies_kids.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.name'),
                  link: '/subscriptions/embroidery/babies-kids/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.quotes'),
                  link: '/subscriptions/embroidery/babies-kids/babies-kids-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.back_to_school'),
                  link: '/subscriptions/embroidery/babies-kids/back-to-school/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.bed_bath'),
                  link: '/subscriptions/embroidery/babies-kids/bed-bath/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.boys_girls'),
                  link: '/subscriptions/embroidery/babies-kids/boys-girls/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.circus_clowns'),
                  link: '/subscriptions/embroidery/babies-kids/circus-clowns/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.cowboy_cowgirl'),
                  link: '/subscriptions/embroidery/babies-kids/cowboy-cowgirl/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.fairy_tales'),
                  link: '/subscriptions/embroidery/babies-kids/fairy-tales-babies-kids//',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.nursery'),
                  link: '/subscriptions/embroidery/babies-kids/nursery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.pirates'),
                  link: '/subscriptions/embroidery/babies-kids/pirates-babies-kids/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.robots_space'),
                  link: '/subscriptions/embroidery/babies-kids/robots-space/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.tedy_bears'),
                  link: '/subscriptions/embroidery/babies-kids/teddy-bears//',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.teenagers'),
                  link: '/subscriptions/embroidery/babies-kids/teenagers/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.babies_kids.toys_games'),
                  link: '/subscriptions/embroidery/babies-kids/toys-games/',
                },
              ],
            },
            {
              id: 'family_friends',
              name: t('navigation.needlework.embroidery_designs.family_friends.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.name'),
                  link: '/subscriptions/embroidery/family-friends/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.adoption'),
                  link: '/subscriptions/embroidery/family-friends/adoption-family-friends/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.quotes'),
                  link: '/subscriptions/embroidery/family-friends/family-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.father'),
                  link: '/subscriptions/embroidery/family-friends/father/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.friends'),
                  link: '/subscriptions/embroidery/family-friends/friends/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.friends_quotes'),
                  link: '/subscriptions/embroidery/family-friends/friends-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.grandchildren'),
                  link: '/subscriptions/embroidery/family-friends/grandchildren/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.grandparents'),
                  link: '/subscriptions/embroidery/family-friends/grandparents/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.mother'),
                  link: '/subscriptions/embroidery/family-friends/mother/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.family_friends.relatives'),
                  link: '/subscriptions/embroidery/family-friends/relatives/',
                },
              ],
            },
            {
              id: 'fashion_beauty',
              name: t('navigation.needlework.embroidery_designs.fashion_beauty.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.fashion_beauty.name'),
                  link: '/subscriptions/embroidery/fashion-beauty/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.fashion_beauty.accessories'),
                  link: '/subscriptions/embroidery/fashion-beauty/accessories/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.fashion_beauty.beauty'),
                  link: '/subscriptions/embroidery/fashion-beauty/beauty/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.fashion_beauty.boho'),
                  link: '/subscriptions/embroidery/fashion-beauty/boho-fashion-beauty/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.fashion_beauty.clothing'),
                  link: '/subscriptions/embroidery/fashion-beauty/boho-fashion-beauty/',
                },
              ],
            },
            {
              id: 'floral_garden',
              name: t('navigation.needlework.embroidery_designs.floral_garden.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.floral_garden.name'),
                  link: '/subscriptions/embroidery/floral-garden/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.floral_garden.bouquets_bunches',
                  ),
                  link: '/subscriptions/embroidery/floral-garden/bouquets-bunches/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.floral_garden.floral_wraths'),
                  link: '/subscriptions/embroidery/floral-garden/floral-wreaths/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.floral_garden.forest_trees'),
                  link: '/subscriptions/embroidery/floral-garden/forest-trees/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.floral_garden.outdoor_quotes'),
                  link: '/subscriptions/embroidery/floral-garden/outdoor-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.floral_garden.outline_flowers'),
                  link: '/subscriptions/embroidery/floral-garden/outline-flowers/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.floral_garden.single_flowers_plants',
                  ),
                  link: '/subscriptions/embroidery/floral-garden/single-flowers-and-plants/',
                },
              ],
            },
            {
              id: 'food_drink',
              name: t('navigation.needlework.embroidery_designs.hobbies_sports.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.name'),
                  link: '/subscriptions/embroidery/hobbies-sports/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.hobbies_sports.camping_fishing',
                  ),
                  link: '/subscriptions/embroidery/hobbies-sports/camping-fishing/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.dance_drama'),
                  link: '/subscriptions/embroidery/hobbies-sports/dance-drama/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.games_leisure'),
                  link: '/subscriptions/embroidery/hobbies-sports/games-leisure/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.music'),
                  link: '/subscriptions/embroidery/hobbies-sports/music-hobbies-sports/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.sewing_crafts'),
                  link: '/subscriptions/embroidery/hobbies-sports/sewing-crafts/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.sports'),
                  link: '/subscriptions/embroidery/hobbies-sports/sports-hobbies-sports/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.hobbies_sports.welness'),
                  link: '/subscriptions/embroidery/hobbies-sports/wellness-hobbies-sports/',
                },
              ],
            },
            {
              id: 'holidays_celebrations',
              name: t('navigation.needlework.embroidery_designs.holidays_celebrations.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.holidays_celebrations.name'),
                  link: '/subscriptions/embroidery/holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.anniversary',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/anniversary-holidays-celebrations/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.holidays_celebrations.baptism'),
                  link: '/subscriptions/embroidery/holidays-celebrations/baptism/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.birthdays',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/birthdays/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.christmas',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/christmas-holidays-celebrations/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.holidays_celebrations.easter'),
                  link: '/subscriptions/embroidery/holidays-celebrations/easter-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.father_day',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/fathers-day-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.graduation',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/graduation/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.halloween',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/halloween-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.indepenence_day',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/independence-day-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.mother_day',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/mothers-day-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.st_patrick',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/st-patricks-day/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.thanksgiving',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/thanksgiving-holidays-celebrations/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.holidays_celebrations.valentine',
                  ),
                  link: '/subscriptions/embroidery/holidays-celebrations/valentines-day-holidays-celebrations/',
                },
              ],
            },
            {
              id: 'house_home',
              name: t('navigation.needlework.embroidery_designs.house_home.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.name'),
                  link: '/subscriptions/embroidery/house-home/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.bathroom'),
                  link: '/subscriptions/embroidery/house-home/bathroom-house-home/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.bedroom'),
                  link: '/subscriptions/embroidery/house-home/bedroom-house-home/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.cleaning'),
                  link: '/subscriptions/embroidery/house-home/cleaning/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.desserts_sweets'),
                  link: '/subscriptions/embroidery/house-home/dessert-sweets/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.farm_country'),
                  link: '/subscriptions/embroidery/house-home/farm-country-house-home/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.food_dining'),
                  link: '/subscriptions/embroidery/house-home/food-dining/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.quotes'),
                  link: '/subscriptions/embroidery/house-home/house-home-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.kitchen_cooking'),
                  link: '/subscriptions/embroidery/house-home/house-home-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.tea_coffee'),
                  link: '/subscriptions/embroidery/house-home/tea-coffee/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.house_home.wine_drinks'),
                  link: '/subscriptions/embroidery/house-home/wine-drinks/',
                },
              ],
            },
            {
              id: 'inspirational_quotes',
              name: t('navigation.needlework.embroidery_designs.shapes.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.shapes.name'),
                  link: '/subscriptions/embroidery/shapes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.shapes.intricate_cuts'),
                  link: '/subscriptions/embroidery/shapes/intricate-cuts-shapes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.shapes.mandala'),
                  link: '/subscriptions/embroidery/shapes/mandala/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.shapes.paisley'),
                  link: '/subscriptions/embroidery/shapes/paisley-shapes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.shapes.zentangle'),
                  link: '/subscriptions/embroidery/shapes/zentangle-shapes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.more_categories.backgrounds'),
                  link: '/subscriptions/embroidery/backgrounds-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.more_categories.borders'),
                  link: '/subscriptions/embroidery/borders/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.more_categories.fonts'),
                  link: '/subscriptions/embroidery/fonts-embroidery/',
                },
              ],
            },
            {
              id: 'nature',
              name: t('navigation.needlework.embroidery_designs.travel_season.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.name'),
                  link: '/subscriptions/embroidery/travel-season/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.autumn'),
                  link: '/subscriptions/embroidery/travel-season/autumn/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.beach_nautical'),
                  link: '/subscriptions/embroidery/travel-season/beach-nautical/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.spring'),
                  link: '/subscriptions/embroidery/travel-season/spring-travel-season/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.summer'),
                  link: '/subscriptions/embroidery/travel-season/summer-travel-season/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.transportation'),
                  link: '/subscriptions/embroidery/travel-season/transportation-travel-season/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.travel_quotes'),
                  link: '/subscriptions/embroidery/travel-season/travel-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.vacation'),
                  link: '/subscriptions/embroidery/travel-season/vacation/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.travel_season.winter'),
                  link: '/subscriptions/embroidery/travel-season/winter-travel-season/',
                },
              ],
            },
            {
              id: 'wedding',
              name: t('navigation.needlework.embroidery_designs.wedding.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.name'),
                  link: '/subscriptions/embroidery/wedding-embroidery/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.bachelor'),
                  link: '/subscriptions/embroidery/wedding-embroidery/bachelor/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.bachelorette'),
                  link: '/subscriptions/embroidery/wedding-embroidery/bachelorette/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.husband'),
                  link: '/subscriptions/embroidery/wedding-embroidery/husband/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.desings'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wedding-designs/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.family'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wedding-family/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.flowers'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wedding-flowers/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.monogram'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wedding-monogram/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.quotes'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wedding-quotes/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.wedding.wife'),
                  link: '/subscriptions/embroidery/wedding-embroidery/wife/',
                },
              ],
            },
            {
              id: 'work_religion_school',
              name: t('navigation.needlework.embroidery_designs.work_religion_school.name'),
              subMenuItems: [
                {
                  name: t('navigation.needlework.embroidery_designs.work_religion_school.name'),
                  link: '/subscriptions/embroidery/work-religion-school/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.work_religion_school.cities_villages',
                  ),
                  link: '/subscriptions/embroidery/work-religion-school/cities-villages/',
                },
                {
                  name: t('navigation.needlework.embroidery_designs.work_religion_school.military'),
                  link: '/subscriptions/embroidery/work-religion-school/military-work-religion-school/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.work_religion_school.religion_faith',
                  ),
                  link: '/subscriptions/embroidery/work-religion-school/religion-faith/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.work_religion_school.school_education',
                  ),
                  link: '/subscriptions/embroidery/work-religion-school/school-education/',
                },
                {
                  name: t(
                    'navigation.needlework.embroidery_designs.work_religion_school.work_occuption',
                  ),
                  link: '/subscriptions/embroidery/work-religion-school/work-occupation/',
                },
              ],
            },
            {
              name: t('navigation.needlework.embroidery_designs.more_categories.view_all'),
              link: '/embroidery/',
              isFootOption: true,
            },
          ],
        },
        {
          id: 'knitting_patterns',
          name: t('navigation.needlework.knitting_patterns.name'),
          link: '/knitting/',
          wrapItems: true,
          trending: {
            title: t('navigation.trending'),
            image:
              'https://www.creativefabrica.com/wp-content/uploads/2024/03/15/knitting-patterns.jpg',
            imageLink: '/knitting/',
          },
          subMenuItems: [
            {
              name: t('navigation.needlework.knitting_patterns.accessories'),
              link: '/knitting/accessories-knitting/',
            },
            {
              name: t('navigation.needlework.knitting_patterns.cloting'),
              link: '/knitting/clothing-knitting/',
            },
            {
              name: t('navigation.needlework.knitting_patterns.home_decor'),
              link: '/knitting/home-decor-knitting/',
            },
            {
              name: t('navigation.needlework.knitting_patterns.toy_dolls'),
              link: '/knitting/toys/',
            },
            {
              name: t('navigation.needlework.knitting_patterns.pets'),
              link: '/knitting/pet-accessories/',
            },
            {
              name: t('navigation.needlework.knitting_patterns.view_all'),
              isFootOption: true,
              link: '/knitting/',
            },
          ],
        },
        {
          id: 'more_patterns',
          name: t('navigation.needlework.more_patterns.name'),
          link: '/subscriptions/graphics/needle-arts/',
          wrapItems: true,
          trending: {
            title: t('navigation.trending'),
            image:
              'https://www.creativefabrica.com/wp-content/uploads/2024/03/14/needlework-patterns.jpg',
            imageLink: '/subscriptions/graphics/needle-arts/',
          },
          subMenuItems: [
            {
              name: t('navigation.needlework.more_patterns.beading'),
              link: '/subscriptions/graphics/needle-arts/beading-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.crochet'),
              link: '/subscriptions/graphics/needle-arts/crochet/',
            },
            {
              name: t('navigation.needlework.more_patterns.cross_stitch'),
              link: '/subscriptions/graphics/needle-arts/cross-stitch-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.hand_embroidery'),
              link: '/subscriptions/graphics/needle-arts/hand-embroidery-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.macrame'),
              link: '/subscriptions/graphics/needle-arts/macrame-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.quilt'),
              link: '/subscriptions/graphics/needle-arts/quilt-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.sewing'),
              link: '/subscriptions/graphics/needle-arts/sewing-patterns/',
            },
            {
              name: t('navigation.needlework.more_patterns.view_all'),
              isFootOption: true,
              link: '/subscriptions/graphics/needle-arts/',
            },
          ],
        },
        {
          id: 'browse_all_needle_arts',
          isFootOption: true,
          name: t('navigation.graphics.browse_all'),
          link: '/subscriptions/graphics/needle-arts/',
        },
      ],
    },
    {
      id: '3d_crafts_laser_cut',
      name: t('navigation.3d.laser_cut.name'),
      link: '/laser-cutting/',
      activePaths: ['/subscriptions/laser-cutting/'],
      subMenuItems: [
        {
          id: '3d-crafts-laser-cut-arts-design',
          name: t('navigation.3d.laser_cut_arts_design.name'),
          link: '/laser-cutting/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_arts_design.files'),
              link: '/laser-cutting/art-design-laser-cutting/cards/',
            },
            {
              name: t('navigation.3d.laser_cut_arts_design.other_arts'),
              link: '/laser-cutting/art-design-laser-cutting/other-art-design-art-design-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_arts_design.signs_laser'),
              link: '/laser-cutting/art-design-laser-cutting/signs/',
            },
            {
              name: t('navigation.3d.laser_cut_arts_design.browse_all'),
              link: '/laser-cutting/',
              isFootOption: true,
            },
          ],
        },
        {
          id: '3d-crafts-laser-cut-celebrations',
          name: t('navigation.3d.laser_cut_celebrations.name'),
          link: '/laser-cutting/celebrations/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_celebrations.birthday'),
              link: '/laser-cutting/celebrations/birthday-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.fathers_day'),
              link: '/laser-cutting/celebrations/fathers-day-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.mothers_day'),
              link: '/laser-cutting/celebrations/mothers-day-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.other'),
              link: '/laser-cutting/celebrations/other-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.valentines_day'),
              link: '/laser-cutting/celebrations/valentines-day-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.wedding'),
              link: '/laser-cutting/celebrations/wedding-celebrations/',
            },
            {
              name: t('navigation.3d.laser_cut_celebrations.browse_all'),
              link: '/laser-cutting/celebrations/',
              isFootOption: true,
            },
          ],
        },
        {
          id: '3d-crafts-laser-home-decor',
          name: t('navigation.3d.laser_cut_home_decor.name'),
          link: '/laser-cutting/home-decor-laser-cutting/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_home_decor.boxes'),
              link: '/laser-cutting/home-decor-laser-cutting/boxes/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.cake_toppers'),
              link: '/laser-cutting/home-decor-laser-cutting/cake-toppers/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.organizers'),
              link: '/laser-cutting/home-decor-laser-cutting/organizers-home-decor-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.ornaments'),
              link: '/laser-cutting/home-decor-laser-cutting/ornaments/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.other'),
              link: '/laser-cutting/home-decor-laser-cutting/other-home-decor/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.shadow_boxes'),
              link: '/laser-cutting/home-decor-laser-cutting/shadow-boxes/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.stands_laser'),
              link: '/laser-cutting/home-decor-laser-cutting/stands/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.wall_decor'),
              link: '/laser-cutting/home-decor-laser-cutting/wall-decor/',
            },
            {
              name: t('navigation.3d.laser_cut_home_decor.browse_all'),
              link: '/laser-cutting/home-decor-laser-cutting/',
              isFootOption: true,
            },
          ],
        },
        {
          id: '3d-crafts-laser-jewelry',
          name: t('navigation.3d.laser_cut_jewelry.name'),
          link: '/laser-cutting/jewelry-laser-cutting/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_jewelry.earrings'),
              link: '/laser-cutting/jewelry-laser-cutting/earrings/',
            },
            {
              name: t('navigation.3d.laser_cut_jewelry.keychains'),
              link: '/laser-cutting/jewelry-laser-cutting/keychains/',
            },
            {
              name: t('navigation.3d.laser_cut_jewelry.other'),
              link: '/laser-cutting/jewelry-laser-cutting/other-jewelry/',
            },
            {
              name: t('navigation.3d.laser_cut_jewelry.browse_all'),
              link: '/laser-cutting/jewelry-laser-cutting/',
              isFootOption: true,
            },
          ],
        },

        {
          id: '3d-crafts-laser-seasonal',
          name: t('navigation.3d.laser_cut_seasonal.name'),
          link: '/laser-cutting/seasonal-designs-laser-cutting/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_seasonal.autumn'),
              link: '/laser-cutting/seasonal-designs-laser-cutting/autumn-halloween-seasonal-designs-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_seasonal.spring'),
              link: '/laser-cutting/seasonal-designs-laser-cutting/spring-easter-seasonal-designs-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_seasonal.summer'),
              link: '/laser-cutting/seasonal-designs-laser-cutting/summer-seasonal-designs-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_seasonal.winter'),
              link: '/laser-cutting/seasonal-designs-laser-cutting/winter-christmas-seasonal-designs-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_seasonal.browse_all'),
              link: '/laser-cutting/seasonal-designs-laser-cutting/',
              isFootOption: true,
            },
          ],
        },
        {
          id: '3d-crafts-laser-toys',
          name: t('navigation.3d.laser_cut_toys.name'),
          link: '/laser-cutting/toys-games-laser-cutting/',
          wrapItems: true,
          trending: {},
          subMenuItems: [
            {
              name: t('navigation.3d.laser_cut_toys.board'),
              link: '/laser-cutting/toys-games-laser-cutting/board-games-toys-games-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_toys.other'),
              link: '/laser-cutting/toys-games-laser-cutting/other-toys-games-toys-games-laser-cutting/',
            },
            {
              name: t('navigation.3d.laser_cut_toys.puzzles'),
              link: '/laser-cutting/toys-games-laser-cutting/puzzles/',
            },
            {
              name: t('navigation.3d.laser_cut_toys.browse_all'),
              link: '/laser-cutting/toys-games-laser-cutting/',
              isFootOption: true,
            },
          ],
        },
        {
          id: 'browse_all_needle_arts',
          isFootOption: true,
          name: t('navigation.graphics.browse_all'),
          link: '/laser-cutting/',
        },
      ],
    },
    {
      id: '3d-printing',
      name: t('navigation.3d-printing'),
      link: '/3d-printing/',
      activePaths: ['/subscriptions/3d-printing/'],
    },
    {
      id: 'bundles',
      name: t('navigation.bundles'),
      link: '/bundles/',
      activePaths: ['/subscriptions/bundles/'],
    },
    {
      id: 'pod',
      name: t('navigation.pod'),
      link: '/pod/',
    },
  ]
}
